import { FC } from "react"

const DefaultBlock: FC = (props) => {
    return (
        <div className="default-block p-3">{props.children}</div>
    )
}

export default DefaultBlock;
